import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { bindActionCreators } from 'redux';
import * as actions from '../../../../actions/type.machine.actions';
import * as home from '../../../../actions/process.home.actions';

import Fab from '@material-ui/core/Fab';
import Hidden from '@material-ui/core/Hidden';

import Menu from '../Menu';
import List from './List';
import Error from '../../../dialogs/Error';
import { AddIcon } from '../../../../images/icons/WrapSvg';

class Machines extends React.Component {
    constructor(props) {
        super(props);
        props.loadMachines();
        this.props.setSearch(true);
    }

    componentWillUnmount() {
        this.props.setSearch(false);
    }

    handleScroll = (e) => {
        this.props.setProminentToolBar(e.currentTarget.scrollTop === 0);
    };

    handleClick = (event) => {
        this.props.history.push('/xef/machines/new_machine');
    };

    handleBack = () => {
        /*
            let path = this.props.history.location.pathname.split('/');
            path.splice(path.length - 1, 1);
            path = path.join('/');
            this.props.history.push(path);
            */
           if(this.props.lastLocation && this.props.lastLocation.pathname === "/user/login") {
            this.props.history.push("/");
        } else {
            this.props.history.goBack();
        }  
    };

    render() {
        const { info } = this.props;
        if (
            info &&
            info.security &&
            info.security.totalPermits &&
            !(info.security.totalPermits.some((f) => f === '20' || f === '59' || f === '67')  &&
              info.security.licencias.some((f) => f.id === 154 && f.activo))
        ) {
            return <Error open id={'unauthorized_access'} handleClose={this.handleBack} />;
        } else {
            return (
                <div className={'flex_full_row bg_ice_blue'}>
                    <Hidden xsDown>
                        <div
                            className={
                                'flex_20 overflow_y_scroll padding_top_12 shadow_right_on_tablet bg_white'
                            }
                            onScroll={this.handleScroll}
                        >
                            <Menu code={5} />
                        </div>
                    </Hidden>
                    <div className={'flex_full_row center'}>
                        <div
                            className={
                                'flex_full overflow_y_scroll center height100 bg_ice_blue showbar'
                            }
                        >
                            <List search={[...this.props.window_searchs]} />
                            <Fab
                                color="primary"
                                aria-label="add"
                                className={'button_float'}
                                onClick={this.handleClick}
                            >
                                <AddIcon />
                            </Fab>
                        </div>
                    </div>
                </div>
            );
        }
    }
}

Machines.propTypes = {
    window_searchs: PropTypes.array.isRequired,
};

const mapStateToProps = (state) => {
    return {
        window_searchs: state.window_searchs,
        info: state.info,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actions, home), dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(Machines));



// WEBPACK FOOTER //
// ./src/components/complex/inventory/machines/Index.js